export enum SpecificDirectoryMap {
  Exercises,
  Help,
  Localizations,
  Research,
  ConsultationNotes,
  None,
  Referrals,
  DeviceData_Exercises,
  ProfilePicture,
  DeviceData_Forms,
  PatientSymptom,
  PatientDiagnosis,
  LibraryArtefactContentMap
}
